import React from 'react';

class IntactSKUs extends React.PureComponent {
  componentDidMount() {
    this.loadGrid();
  }

  loadGrid = () => {
    try {
      const intactSKUsGrid = new Greenmile.RouteSummary.IntactSKUs.Grid();
      intactSKUsGrid.init();
    } catch (error) {
      console.log(`${error.message}`)
    }
  }

  render() {
    return (
      <div data-testid="intactSKUsGrid" id="stockSummaryGrid">
        <div className="gridActions_intact" />
        <div id="grid_intact" />
      </div>
    );
  }
}

export default IntactSKUs;
